"use client";

import { useAuth } from "@/contexts/auth-context";

export function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();
  if (!impersonation) return null;
  const label =
    impersonation.targetEmail ??
    impersonation.targetUid.slice(0, 8) + "…";
  const orgSuffix = impersonation.targetOrgName ? ` (${impersonation.targetOrgName})` : "";
  return (
    <div className="w-full bg-amber-300 text-amber-950 text-sm px-4 py-1.5 flex items-center justify-between gap-3 sticky top-0 z-50 border-b border-amber-500">
      <span>
        <strong className="font-semibold">Staff impersonation:</strong>{" "}
        acting as <span className="font-mono">{label}</span>
        {orgSuffix}. Every action is logged in their audit feed.
      </span>
      <button
        type="button"
        className="px-2 py-0.5 rounded bg-amber-950 text-amber-50 hover:bg-amber-900 text-xs font-medium"
        onClick={() => void stopImpersonation()}
      >
        End session
      </button>
    </div>
  );
}
